import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mb-form-field',
  templateUrl: './mb-form-field.component.html',
  styleUrls: ['./mb-form-field.component.scss']
})
export class MbFormFieldComponent implements OnInit {

  @Input() title;
  @Input() rightItem;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() preicon: boolean;
  @Input() posticon: boolean;
  @Input() lowercase: boolean;

  constructor() { }

  ngOnInit() { }

}
